import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useMediaQuery, useTheme } from '@mui/material';
import routes from '../routes';
import * as authService from '../services/auth';
import { Roles } from '../models/roles';
import ViewNotSupportedCard from './ViewNotSupportedCard/ViewNotSupportedCard';

const PrivateRoute = ({ component: Component, forceRender = false, ...rest }) => {
  let hasAccess = true;
  let pathname = '';
  const user = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.only('xs'));

  if (!authService.getCurrentlyLoggedInUser()) {
    hasAccess = false;
    pathname = routes.login;
  }

  const render = props => {

    if (hasAccess) {
      const component = <Component {...props} isMobileView={isMobileView} />;

      if (forceRender) {
        return component;
      }

      const isRescuer = authService.hasRoleInAnySite(user, Roles.Rescuer);
      const isDonor = authService.hasAnyRoleInCurrentlySelectedSite(user, [
        Roles.DonorAdmin,
        Roles.DonorStaff,
        Roles.DonorLocationStaff,
        Roles.DonorLocationAdmin,
        Roles.SiteDirector,
        Roles.SiteCoordinator,
      ]);
      const isReceiver = authService.hasAnyRoleInCurrentlySelectedSite(user, [
        Roles.ReceiverLocationAdmin,
        Roles.ReceiverLocationStaff,
        Roles.ReceiverAdmin,
        Roles.ReceiverStaff,
      ]);
      if ((!isDonor && !isRescuer && !isReceiver) && isMobileView) {
        return <ViewNotSupportedCard {...props} isMobileView={isMobileView} />
      }

      return component;
    }

    return <Redirect to={{ pathname, state: { from: rest.location } }} />;
  };

  return <Route {...rest} render={render} />;
};

export default PrivateRoute;
